// extracted by mini-css-extract-plugin
export default {"reviewsContainer":"ThirdSection_reviewsContainer__APkN+","reviewBoxOuter":"ThirdSection_reviewBoxOuter__8WXWu"};